module.exports = __webpack_public_path__ + "vrplayerstatic/media/hotspot-arrow.733e1902.svg";